/** Raw Pax credits in one displayed Pax credit. */
export const RAW_PAX_CREDITS_PER_DISPLAY_CREDIT = 50_000_000_000n;
